import { useState, useEffect } from "react";
import MovieCard from "../components/MovieCard";
import MovieModal from "../components/MovieModal";

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [showModal, setShowModal] = useState(false);

 useEffect(() => {
  const saved = localStorage.getItem("favorites");
  setFavorites(saved ? JSON.parse(saved) : []);
}, []);

const removeFavorite = (movie) => {
  const updated = favorites.filter((m) => m.imdbID !== movie.imdbID);
  setFavorites(updated);
  localStorage.setItem("favorites", JSON.stringify(updated));
};


  return (
    <div className="app">
      <h1>My Favorites</h1>

      {favorites.length > 0 ? (
        <div className="container">
          {favorites.map((movie) => (
            <div key={movie.imdbID} onClick={() => { setSelectedMovie(movie); setShowModal(true); }}>
              <MovieCard movie={movie} />
              <button
                className="fav-btn"
                onClick={(e) => { e.stopPropagation(); removeFavorite(movie); }}
              >
                Remove ❤️
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty"><h2>No favorites yet</h2></div>
      )}

      {showModal && selectedMovie && (
        <MovieModal movie={selectedMovie} onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

export default Favorites;
